import { render, staticRenderFns } from "./ViaggiTreno.vue?vue&type=template&id=1dc2d25a&scoped=true"
import script from "./ViaggiTreno.vue?vue&type=script&lang=js"
export * from "./ViaggiTreno.vue?vue&type=script&lang=js"
import style0 from "./ViaggiTreno.vue?vue&type=style&index=0&id=1dc2d25a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc2d25a",
  null
  
)

export default component.exports